import React from "react"
import PropTypes from "prop-types"

function CaretDownIcon({ color = "#4F2170", width = "14", height = "12" }) {
    return (
        <svg width={width} height={height} viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.9891 0.596925C13.8246 0.1285 13.0011 0.34603 12.3045 0.395409C11.9133 0.423434 9.26198 0.292649 8.87079 0.277969C7.84056 0.243271 7.19212 0.264624 5.15868 0.257951C3.90877 0.253947 4.40333 0.292649 3.15343 0.287311C2.90556 0.287311 2.29706 0.211242 1.34553 0.356707C1.07417 0.398078 0.124998 0.208573 0.0380688 0.455463C-0.151061 0.993284 0.404581 1.74997 0.822783 2.33717C2.93023 5.29318 4.08733 7.14953 5.92459 10.2724C6.13135 10.6233 6.58596 11.7791 7.05585 11.9045C7.71722 12.0807 7.95451 11.0504 8.20003 10.5967C9.06462 8.99521 9.94801 7.40043 10.8478 5.81499C11.8675 4.01869 14.1782 1.13875 13.9891 0.596925Z"
                fill={color}
            />
        </svg>
    )
}

CaretDownIcon.propTypes = {
    color: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
}

export default CaretDownIcon
